import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-flex-1 tw-text-left tw-text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationCircle = _resolveComponent("ExclamationCircle")!
  const _component_TablerLock = _resolveComponent("TablerLock")!
  const _component_ExclamationTriangle = _resolveComponent("ExclamationTriangle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-px-4 tw-py-2', _ctx.colorClass])
  }, [
    _createElementVNode("div", null, [
      (_ctx.type === 'info')
        ? (_openBlock(), _createBlock(_component_ExclamationCircle, {
            key: 0,
            class: "tw-h-5 tw-w-5"
          }))
        : (_ctx.type === 'lock')
          ? (_openBlock(), _createBlock(_component_TablerLock, { key: 1 }))
          : (_openBlock(), _createBlock(_component_ExclamationTriangle, {
              key: 2,
              class: "tw-h-5 tw-w-5"
            }))
    ]),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}